import { render, staticRenderFns } from "./PsychometryView.vue?vue&type=template&id=a16b6f8e&scoped=true&"
import script from "./PsychometryView.vue?vue&type=script&lang=js&"
export * from "./PsychometryView.vue?vue&type=script&lang=js&"
import style0 from "./PsychometryView.vue?vue&type=style&index=0&id=a16b6f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b6f8e",
  null
  
)

export default component.exports